import React from 'react';

import { ReactFCV } from '@types';

import { StyledGrid, StyledRow } from '../style';

import { ICartLayoutProps } from './model';
import {
  StyledAdditionalInfoColumn,
  StyledButtonCol,
  StyledIconColumn,
  StyledInfoColumn,
  StyledPriceColumn,
  StyledPricePerPieceColumn,
  StyledQuantityColumn,
  StyledTextColumn,
} from './styled';
import { getLayout } from './utils';

export const CartLayout: ReactFCV<ICartLayoutProps> = (props) => {
  const layout = getLayout(props);

  if (!layout) {
    return null;
  }

  return (
    <StyledGrid fluid={true} {...props}>
      <StyledRow visible={layout.firstRow.visible}>
        <StyledIconColumn {...layout.firstRow.firstColumn.deviceSettings} {...layout.firstRow.firstColumn.size}>
          {props.iconColumn?.({ active: props.serviceActive, disabled: props.serviceDisabled })}
        </StyledIconColumn>
        <StyledTextColumn
          data-testid="cart-layout-text-column"
          active={props.serviceActive}
          disabled={props.serviceDisabled}
          {...layout.firstRow.secondColumn.deviceSettings}
          {...layout.firstRow.secondColumn.size}>
          {props.bodyColumn?.({ active: props.serviceActive, disabled: props.serviceDisabled })}
        </StyledTextColumn>
        <StyledPriceColumn
          active={props.serviceActive}
          disabled={props.serviceDisabled}
          {...layout.firstRow.thirdColumn.deviceSettings}
          {...layout.firstRow.thirdColumn.size}>
          {props.priceColumn?.({ active: props.serviceActive, disabled: props.serviceDisabled })}
        </StyledPriceColumn>
        <StyledButtonCol {...layout.firstRow.fourthColumn.deviceSettings} {...layout.firstRow.fourthColumn.size}>
          {props.buttonColumn?.({ active: props.serviceActive, disabled: props.serviceDisabled })}
        </StyledButtonCol>
      </StyledRow>
      <StyledRow visible={layout.secondRow.visible}>
        <StyledIconColumn {...layout.secondRow.firstColumn.deviceSettings} {...layout.secondRow.firstColumn.size} />
        <StyledInfoColumn
          active={props.serviceActive}
          disabled={props.serviceDisabled}
          {...layout.secondRow.secondColumn.deviceSettings}
          {...layout.secondRow.secondColumn.size}>
          {props.infoColumn?.({ active: props.serviceActive, disabled: props.serviceDisabled })}
        </StyledInfoColumn>
      </StyledRow>
      <StyledRow visible={layout.thirdRow.visible}>
        <StyledIconColumn {...layout.thirdRow.firstColumn.deviceSettings} {...layout.thirdRow.firstColumn.size} />
        <StyledAdditionalInfoColumn
          {...layout.thirdRow.secondColumn.deviceSettings}
          {...layout.thirdRow.secondColumn.size}>
          {props.additionalColumn?.({ active: props.serviceActive, disabled: props.serviceDisabled })}
        </StyledAdditionalInfoColumn>
        <StyledPricePerPieceColumn
          {...layout.thirdRow.thirdColumn.deviceSettings}
          {...layout.thirdRow.thirdColumn.size}>
          {props.perPieceColumn?.({ active: props.serviceActive, disabled: props.serviceDisabled })}
        </StyledPricePerPieceColumn>
        <StyledQuantityColumn {...layout.thirdRow.fourthColumn.deviceSettings} {...layout.thirdRow.fourthColumn.size}>
          {props.piecesColumn?.({ active: props.serviceActive, disabled: props.serviceDisabled })}
        </StyledQuantityColumn>
        <StyledPriceColumn
          active={props.serviceActive}
          disabled={props.serviceDisabled}
          {...layout.thirdRow.fifthColumn.deviceSettings}
          {...layout.thirdRow.fifthColumn.size}>
          {props.priceColumn?.({ active: props.serviceActive, disabled: props.serviceDisabled })}
        </StyledPriceColumn>
      </StyledRow>
    </StyledGrid>
  );
};
